import { http } from "./api";

export const authenticateUser = async (credentials) => {
    try {
        const response = await http.post("v1/auth/login-partner", credentials);

        if (!response.success && response.requestCode === 401) {
            return {
                success: false,
                requestCode: response.requestCode,
                message: "Credenciales incorrectas",
            };
        }

        if (!response.success && response.requestCode === 400) {
            return {
                success: false,
                requestCode: response.requestCode,
                message:
                    "La contraseña debe tener una letra mayúscula, una minúscula y un número",
            };
        }

        return response;
    } catch (error) {
        console.error("Error during authentication:");
    }
};
